import React, {useState} from 'react'

function isElectron() {
  // Renderer process
  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
    return true;
  }

  // Main process
  if (typeof process !== 'undefined' && typeof process?.versions === 'object' && !!process?.versions.electron) {
    return true;
  }

  // Detect the user agent when the `nodeIntegration` option is set to true
  if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
    return true;
  }

  return false;
}

const AdminContext = React.createContext()
AdminContext.displayName = 'AdminContext'

function AdminProvider(props) {
  const [isAdmin, setIsAdmin] = useState(false);

  React.useEffect(() => {
    if (isElectron()) {
      window.api?.receive("adminFromMain", (data) => {
        console.log('Received admin='+data+' in adminFromMain from Main process');
        if (data) {
          setIsAdmin(true);
        }
      });
      window.api?.receive("fromMain", (data) => {
        console.log('Received admin='+data+' in adminFromMain from Main process');
        if (data) {
          setIsAdmin(true);
        }
      });
      // Send a message to the main process
      window.api?.send("asyncToMain", "admin");
      console.log('sent toMain request to Main Process');
    }
    }, [])

  const value = React.useMemo(() => ({ isAdmin }), [
    isAdmin,
  ])
  return <AdminContext.Provider value={value} {...props} />
}

function useAdmin() {
  const context = React.useContext(AdminContext)
  if (context === undefined) {
    throw new Error('useAdmin must be used within a AdminProvider');
  }
  return context
}

export { AdminProvider, useAdmin }